import { Button, ButtonGroup } from '@mui/material';
import { useTheme } from '@mui/material/styles';

export type GroupButtonPeriodValue = string | number | null;

export interface GroupButtonPeriodOption<
  TValue extends GroupButtonPeriodValue,
> {
  period: TValue;
  buttonText: string;
}

export interface GroupButtonPeriodProps<TValue extends GroupButtonPeriodValue> {
  periods: GroupButtonPeriodOption<TValue>[];
  selectedPeriod: TValue;
  handlePeriodChange: (period: TValue) => void;
  ariaLabel?: string;
  disabled?: boolean;
}

export function GroupButtonPeriod<TValue extends GroupButtonPeriodValue>({
  periods,
  selectedPeriod,
  handlePeriodChange,
  ariaLabel = 'Período do gráfico',
  disabled = false,
}: GroupButtonPeriodProps<TValue>) {
  const theme = useTheme();

  return (
    <ButtonGroup
      variant="contained"
      color="inherit"
      size="small"
      aria-label={ariaLabel}>
      {periods.map(({ period, buttonText }) => {
        const isSelected = selectedPeriod === period;

        return (
          <Button
            key={String(period)}
            size="small"
            disabled={disabled}
            sx={{
              backgroundColor: isSelected
                ? theme.palette.primary.main
                : 'common.white',
              color: isSelected
                ? theme.palette.primary.contrastText
                : theme.palette.secondary.main,
              '&:hover': {
                backgroundColor: isSelected
                  ? theme.palette.primary.dark
                  : theme.palette.grey[100],
              },
            }}
            onClick={() => handlePeriodChange(period)}>
            {buttonText}
          </Button>
        );
      })}
    </ButtonGroup>
  );
}
